import shared from "./shared";

function saveData(state) {
  const data = {
    tableHeaders: state.tableHeaders,
    defaultTableHeaders: state.defaultTableHeaders,
    showTable: state.showTable,
    showAll: state.showAll,
  };

  localStorage.setItem("tableBt", JSON.stringify(data));
}

function newAssignedTo(headers, data) {
  //Set new assegined to
  if (headers) {
    const head = headers.find((x) => x.isAssignedTo);

    if (head) {
      head.filterValues = data.value
        ? (shared as any).state?.isTrysilhus
          ? ""
          : (shared as any).state?.contactPersonContactIds
        : (shared as any).state?.profile?.id;
      head.disabled = !data.value;
    }
  }
}

export default {
  namespaced: true,

  state: {
    tableHeaders: {},
    defaultTableHeaders: {},
    showTable: false,
    showAll: {
      id: "",
      value: false,
    },
    filter: null,
  },
  getters: {
    tableHeaders: (state) => {
      return state.tableHeaders;
    },
    defaultTableHeaders: (state) => {
      return state.defaultTableHeaders;
    },
    showTable: (state) => {
      return state.showTable;
    },
    showAll: (state) => {
      return state.showAll;
    },
    filter: (state) => {
      return state.filter;
    },
  },
  mutations: {
    tableHeaders(state, data) {
      state.tableHeaders = data;
    },
    defaultTableHeaders(state, data) {
      state.defaultTableHeaders = data;
    },
    showTable(state, data) {
      state.showTable = data;
    },
    showAll(state, data) {
      state.showAll = data;
    },
    setFilter(state, filter) {
      state.filter = filter;
    },
    resetFilter(state) {
      state.filter = null;
    },
  },
  actions: {
    async getHeaderData(context, tableId) {
      return new Promise((resolve) => {
        const data = JSON.parse((localStorage as any).getItem("tableBt"));
        if (tableId === data?.tableHeaders?.tableId) {
          context.commit("tableHeaders", data.tableHeaders);
          context.commit("defaultTableHeaders", data.defaultTableHeaders);
          context.commit("showTable", data.showTable);
          context.commit("showAll", data.showAll);
        }
        resolve(true);
      });
    },
    tableHeaders({ state, commit }, data) {
      return new Promise((resolve) => {
        //Check if default is saved
        if (
          !state.defaultTableHeaders?.tableId ||
          state.defaultTableHeaders?.tableId !== data.tableId
        ) {
          //Use this if user want to reset filter. Then default filter is used
          commit("defaultTableHeaders", JSON.parse(JSON.stringify(data)));
        }

        if (state.filter?.headers?.length > 0) {
          // filter
          state.filter.headers.forEach((x) => {
            const head = data.headers.find(
              (h) => h.filterName === x.filterName
            );
            if (head) {
              head.filterValues = x.filterValues;
            }
          });

          commit("resetFilter", data);
        }
        commit("tableHeaders", data);

        saveData(state);

        resolve(true);
      });
    },
    resetToDefault(context) {
      context.commit(
        "tableHeaders",
        JSON.parse(JSON.stringify(context.state.defaultTableHeaders))
      );
    },
    setShowTable({ state, commit }, value) {
      commit("showTable", value);
      saveData(state);
    },
    setShowAll(context, data) {
      //Gjøre dette til funksjon!
      newAssignedTo(context.state.tableHeaders?.headers, data);

      // update default
      newAssignedTo(context.state.defaultTableHeaders?.headers, data);

      context.commit("showAll", data);
    },
    setFilter({ commit }, filter) {
      commit("setFilter", filter);
    },
  },
};
